import { StrictMode } from "react";
import { createRoot, hydrateRoot } from "react-dom/client";

import { App, loadInitialRoute } from "@/app";

const root = document.getElementById("root");

if (!root) {
  throw new Error("Missing #root application mount.");
}

if (root.dataset.prerendered === "true" && root.hasChildNodes()) {
  const initialRoute = await loadInitialRoute(window.location.pathname);
  hydrateRoot(
    root,
    <StrictMode>
      <App initialRoute={initialRoute} />
    </StrictMode>,
  );
} else {
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
